import React from 'react';

import { groupingByOptions, utilizationOptions, vehicleSituationOptions } from './vehicle-synthetic-report-options';

import CompanyListHelper from '../../../helpers/list-helpers';
import CompanyFormatHelper from '../../../helpers/format-helpers';

import { useStipReport } from '../../../hooks/use-stip-report';
import { useFetchCompanies } from '../../../hooks/fetch/use-fetch-companies';
import { useFetchSubsystems } from '../../../hooks/fetch/use-fetch-subsystems';
import { useFetchPersonTypes } from '../../../hooks/fetch/use-fetch-person-types';
import { useFetchCompanyTypes } from '../../../hooks/fetch/use-fetch-company-types';
import { useFetchVehicleTypes } from '../../../hooks/fetch/use-fetch-vehicle-types';

import Loading from '../../../../../layouts/Loading';

import { GridItem } from '../../../components/GridItem';
import { ReportSelect } from '../../../components/ReportSelect';
import { ReportRadioGroup } from '../../../components/ReportRadioGroup';
import { ReportMultiSelect } from '../../../components/ReportMultiSelect';
import { ReportSectionTitle } from '../../../components/ReportSectionTitle';
import { ReportMultiAutocomplete } from '../../../components/ReportMultiAutocomplete';
import { useFetchPlates } from '../../../hooks/fetch/use-fetch-plates';
import { ReportPlateSelection } from '../../../components/ReportPlateSelection';

const VehicleSyntheticReport = () => {
    // eslint-disable-next-line
    const { handleRadioChange, _, handleSelectChange } = useStipReport();

    const { loading: loadingCompanies, companies } = useFetchCompanies({ boWithUsers: true });
    const { loading: loadingVehicles, vehicleTypes } = useFetchVehicleTypes();
    const { loading: loadingSubsystems, subsystems } = useFetchSubsystems();
    const { loading: loadingPersonTypes, personTypes } = useFetchPersonTypes();
    const { loading: loadingCompanyTypes, companyTypes } = useFetchCompanyTypes();
    const { loading: loadingPlates, plates } = useFetchPlates();

    const loading =
        loadingCompanyTypes ||
        loadingCompanies ||
        loadingPersonTypes ||
        loadingVehicles ||
        loadingPlates ||
        loadingSubsystems;

    if (loading) {
        return <Loading />;
    }

    return (
        <GridItem container spacing={3}>
            <GridItem>
                <ReportSectionTitle>Opções de filtro:</ReportSectionTitle>
            </GridItem>
            <GridItem>
                <ReportRadioGroup
                    label="Situação do veículo:"
                    options={vehicleSituationOptions}
                    name={'situacaoVeiculos'}
                    onSelect={handleRadioChange}
                />
            </GridItem>

            <GridItem>
                <ReportSectionTitle divider />
            </GridItem>
            <GridItem sm={6}>
                <ReportSectionTitle gutterBottom>Tipos de operador PJ:</ReportSectionTitle>
                <ReportMultiSelect
                    options={companyTypes}
                    onSelect={handleSelectChange}
                    label="Selecione tipos de operador PJ"
                    name="tiposEmpresa"
                    valueProperty="cdTipoEmpresa"
                    labelProperty="deTipoEmpresa"
                />
            </GridItem>
            <GridItem sm={6}>
                <ReportSectionTitle gutterBottom>Tipos de operador PF:</ReportSectionTitle>
                <ReportMultiSelect
                    options={personTypes}
                    onSelect={handleSelectChange}
                    label="Selecione tipos de operador PF"
                    name="tiposPessoaFisica"
                    valueProperty="cdTipoPessoaFisica"
                    labelProperty="deTipoPessoaFisica"
                />
            </GridItem>

            <GridItem>
                <ReportSectionTitle divider />
            </GridItem>
            <GridItem sm={6}>
                <ReportSectionTitle gutterBottom>Selecione o(s) operador(es):</ReportSectionTitle>
                <ReportMultiAutocomplete
                    options={CompanyListHelper.parseDocumentNumber(companies)}
                    onSelect={handleSelectChange}
                    label="Todos os operadores"
                    name="usuarios"
                    valueProperty="deCpfCnpj"
                    labelProperty="deRazaoSocial"
                    getOptionLabel={CompanyFormatHelper.getLabelDeRazaoSocialOrNmCompleto}
                    limitTags={1}
                />
            </GridItem>
            <GridItem sm={6}>
                <ReportSectionTitle gutterBottom>Tipos de veículos:</ReportSectionTitle>
                <ReportMultiSelect
                    options={vehicleTypes}
                    onSelect={handleSelectChange}
                    label="Selecione tipos de veículos"
                    name="tiposVeiculo"
                    valueProperty="cdTipoVeiculo"
                    labelProperty="deTipoVeiculo"
                />
            </GridItem>
            <GridItem sm={6}>
                <ReportSectionTitle gutterBottom>Subsistema:</ReportSectionTitle>
                <ReportMultiSelect
                    options={subsystems}
                    onSelect={handleSelectChange}
                    label="Selecione o subsistema"
                    name="subSistemas"
                    valueProperty="cdSubSistema"
                    labelProperty="deSubSistema"
                />
            </GridItem>
            <GridItem sm={6}>
                <ReportSectionTitle gutterBottom>Utilização:</ReportSectionTitle>
                <ReportSelect
                    options={utilizationOptions}
                    name="deUtilizacao"
                    label="Selecione a utilização"
                    onSelect={handleSelectChange}
                />
            </GridItem>
            <GridItem sm={6}>
                <ReportPlateSelection fieldName="placas" plates={plates} loading={loadingPlates} />
            </GridItem>

            <GridItem>
                <ReportSectionTitle divider>Opções de agrupamento:</ReportSectionTitle>
            </GridItem>
            <GridItem sm={6}>
                <ReportSelect options={groupingByOptions} name="agrupamento" onSelect={handleSelectChange} />
            </GridItem>
        </GridItem>
    );
};

export default VehicleSyntheticReport;
